import React, { Component } from 'react'
import DialogWrapper from '../../../components/DialogWrapper'
import DatePickerComponent from '../../../components/DatePickerComponent'
import { Button, IconButton, Switch, Typography } from '@mui/material';
import EntitySelectionContent from '../../../components/EntitySelection/EntitySelectionContent';
import { APIData } from '../../../constants/APIAdresses';
import { ALERT_SEVERITY } from '../../../components/AlertDisplay2';
import IntegerAmountSelector from '../../../components/IntegerAmountSelector';
import PriceInput from '../../../components/PriceInput';
import VoucherDisplayCard from '../../../components/VoucherDisplayCard';
import { generateBulkGiftcards } from '../../../APIHelper';

export class GiftCardDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qty: 1,
            validUntil: null,
            onlySelectedShops: true,
            selectedShops: [{ id: props.shopId }],
            editMode: false,
            value: null,
            results: [],
        }
    }
    filterEntitySelectionResults(result) {
        const { editMode } = this.state;
        if (!editMode) {
            return result.map(item => {
                const { added, ...rest } = item;
                return rest;
            }).filter(item => item.deselected !== true); // also remove deselected ones in creation mode, since they are not relevant at all
        }
        return result;
    }

    onMainBtnClick = async () => {
        if (this.state.results.length > 0) {
            this.props.onClose();
        } else {
            // create giftcard
            const { value, validUntil, onlySelectedShops, selectedShops } = this.state;
            const { companyId } = this.props;
            const body = {
                ...(this.state.validUntil != null ? { expirationDate: this.state.validUntil.toISOString() } : {}),
                amount: parseFloat(this.state.value.replace(",", ".")),
                // sending neither shopIdList nor companyId will let the backend use the companyId from the session. Exact behavior we want in that case.
                // ...(this.state.selectedCompanyId == null ? { shopIdList: this.state.selectedShops.map(item => item.id) } : {}),
                quantity: this.state.qty ?? 1,
            }
            console.log("Creating giftcard with body: ", body);
            if (!this.props.platformMode) {
                console.log("Current platformMode: ", this.props.platformMode, " BODY BEFORE: ", body);
                // if not platform mode we have to specify either the companyId or shopIdList:
                Object.assign(body, this.state.onlySelectedShops ? { shopIdList: this.state.selectedShops.map(item => item.id), companyId } : { companyId });
            }
            console.log("Final body to send for giftcard creation: ", body);
            if (!isNaN(body.amount)) {
                const res = await generateBulkGiftcards(body);
                if (res) {
                    this.setState({
                        results: res
                    })
                    console.log("Giftcards created successfully with response: ", res);
                } else {
                    window.alert("Fehler bei der Erstellung der Gutscheinkarten. Bitte versuche es später erneut.");
                }
            } else {
                window.alert("Bitte geben Sie einen gültigen Wert ein.");
            }
        }
    }
    render() {
        const { shopId, companyId, platformMode, ...rest } = this.props;
        return (
            <DialogWrapper
                actions={
                    <>
                        {this.state.results.length == 0 && <Button variant='contained' color='error' onClick={() => { this.props.onClose() }}>Abbrechen</Button>}
                        <Button variant='contained' color='primary' onClick={() => { this.onMainBtnClick() }}>{this.state.results.length > 0 ? "Schließen" : "Erstellen"}</Button>
                    </>
                }
                fixedHeight={800} maxWidth='md' {...rest}>

                <div style={{ display: "flex", overflow: "scroll", flexDirection: "column", gap: 15 }}>
                    {this.state.results.length > 0 ?
                        <>
                            <p>🎊 Gutscheine erstellt! 🎊<br />Notiere dir die folgenden Gutscheincodes:</p>
                            {

                                this.state.results.map((voucher, index) => (
                                    <VoucherDisplayCard key={"VOUCHERDISPLAY_" + index}
                                        voucherCode={voucher.code}
                                        value={voucher.balance}
                                        pin={voucher.pin}
                                        expiresAt={voucher.expiresAt}
                                        {...voucher} />
                                ))
                            }
                        </>
                        :
                        <>
                            <PriceInput value={this.state.value} setValue={(newValue) => this.setState({ value: newValue })} />
                            <Typography>Anzahl (Max. 10)</Typography>
                            <IntegerAmountSelector minValue={1} maxValue={10} value={this.state.qty} onChange={(newValue) => this.setState({ qty: newValue })} />
                            <div style={{ display: "flex", gap: 5 }}>
                                <DatePickerComponent
                                    label="Gültig bis"
                                    value={this.state.validUntil}
                                    onChange={(newValue) => this.setState({ validUntil: newValue })}
                                />
                                {this.state.validUntil && (
                                    <IconButton color="error" style={{ width: 50, height: 50 }} onClick={() => this.setState({ validUntil: null })}>
                                        X
                                    </IconButton>
                                )}
                            </div>
                            {!platformMode &&
                                <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}>
                                        <Switch
                                            checked={this.state.onlySelectedShops}
                                            onChange={(event) => this.setState({ onlySelectedShops: event.target.checked })}
                                            color="primary"
                                            name="onlySelectedShops"
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                        <Typography>Nur für ausgewählte Shops gültig</Typography>
                                    </div>
                                    <Typography variant='subtitle2' color="textSecondary">Gutschein gilt für alle Shops, wenn der Switch deaktiviert ist.</Typography>
                                    {this.state.onlySelectedShops && (
                                        <EntitySelectionContent
                                            title="Shops auswählen"
                                            icon={require('../../../assets/icons/store.png')}
                                            apiEndpoint={(page, ipp, search) => `${APIData.SHOP}/getShopsPaginated?page=${page}&ipp=${ipp}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}&companyId=${companyId}`}
                                            method="GET"
                                            body={undefined}
                                            keyFieldName="id"
                                            multipleSelection={true}
                                            deselectionDisabled={this.state.editMode}
                                            value={this.state.selectedShops}
                                            searchPlaceholder="Suche"
                                            additionalKeysToAdd={[]}
                                            onChange={(selectedItems) => {
                                                const finalItems = this.filterEntitySelectionResults(selectedItems);
                                                console.log("SELECTED SHOPS FOR GIFTCARD: ", finalItems, " SELECTED ITEMS FROM COMPONENT: ", selectedItems);
                                                if (finalItems?.length > 0) {
                                                    this.setState({
                                                        selectedShops: finalItems
                                                    });
                                                } else {
                                                    this.props.showAlert("Letzte Shop kann nicht gelöscht werden!", ALERT_SEVERITY.WARNING);
                                                }
                                            }}
                                            renderChipContent={(item) => (
                                                <div style={{ flex: 1 }}>
                                                    <div
                                                        style={{
                                                            fontSize: "0.95rem",
                                                            color: "#353535"
                                                        }}
                                                    >
                                                        <span style={{ fontWeight: 600 }}>
                                                            Shop:
                                                        </span>{" "}
                                                        {item.name}{" "}
                                                        <span style={{ fontWeight: 600 }}>
                                                            ID:
                                                        </span>{" "}
                                                        ({item.id})
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "0.9rem",
                                                            color: "#676767"
                                                        }}
                                                    >
                                                        Adresse: {item.street} {item.houseNumber},{" "}
                                                        {item.zip} {item.city}
                                                    </div>
                                                </div>
                                            )}
                                        />
                                    )}
                                </div>
                            }
                        </>
                    }
                </div>
            </DialogWrapper>
        )
    }
}

export default GiftCardDialog

const exampleVouchers = [
    {
        voucherCode: "ABCD-1234-EFGH",
        pin: "4821",
        value: 25.00,
        expiresAt: "2026-12-31T23:59:00Z"
    },
    {
        voucherCode: "ZXCV-5678-QWER",
        pin: "9034",
        value: 10.50,
        expiresAt: "2026-08-15T21:00:00Z"
    },
    {
        voucherCode: "LMNO-2468-PQRS",
        pin: "7712",
        value: 50.00,
        expiresAt: null
    },
    {
        voucherCode: "GHJK-1357-TYUI",
        pin: "6609",
        value: 5.75,
        expiresAt: "2027-01-01T00:00:00Z"
    },
    {
        voucherCode: "WXYZ-8642-ASDF",
        pin: "1183",
        value: 100.00,
        expiresAt: "2026-10-10T20:00:00Z"
    }
];